import { render } from "./BarChartIcon16.vue.js?vue&type=template&id=73c671cc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./BarChartIcon16.vue?vue&type=template&id=73c671cc"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__